var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-content-start":"","wrap":"","fill-height":"","pa-2":"","mx-4":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }